import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const BeforeAfterGallery = () => {
  const [activeSlide, setActiveSlide] = useState(0);
  const [sliderPosition, setSliderPosition] = useState(50);

  const galleryItems = [
    {
      id: 1,
      title: "Pembersihan AC Split Rumah Tinggal",
      location: "Bekasi Selatan",
      beforeImage: "/assets/images/before1.png",
      afterImage: "/assets/images/after1.png",
      problem: "Filter kotor, sirip evaporator berdebu tebal",
      solution: "Cuci menyeluruh dengan chemical khusus",
      result: "Udara lebih sejuk, hemat listrik 30%"
    },
    {
      id: 2,
      title: "Perbaikan AC Kantor",
      location: "Tambun Selatan", 
      beforeImage: "/assets/images/before.png",
      afterImage: "/assets/images/after.png",
      problem: "Kompresor rusak, freon habis",
      solution: "Ganti kompresor, isi ulang freon R32",
      result: "AC kembali dingin optimal, garansi 1 tahun"
    },
    {
      id: 3,
      title: "Instalasi AC Baru",
      location: "Jakarta Timur",
      beforeImage: "/assets/images/before2.png",
      afterImage: "/assets/images/after2.png",
      problem: "Ruangan panas, belum ada AC",
      solution: "Instalasi AC 1.5 PK dengan pipa tembaga",
      result: "Ruangan sejuk, instalasi rapi dan aman"
    }
  ];

  const handleSliderChange = (e) => {
    setSliderPosition(e?.target?.value);
  };

  const nextSlide = () => {
    setActiveSlide((prev) => (prev + 1) % galleryItems?.length);
    setSliderPosition(50);
  };

  const prevSlide = () => {
    setActiveSlide((prev) => (prev - 1 + galleryItems?.length) % galleryItems?.length);
    setSliderPosition(50);
  };

  const currentItem = galleryItems?.[activeSlide];

  return (
    <section className="py-16 lg:py-24 bg-background">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center bg-accent/10 text-accent px-4 py-2 rounded-full text-sm font-medium mb-6">
            <Icon name="Camera" size={16} className="mr-2" />
            Hasil Kerja Nyata
          </div>
          <h2 className="font-heading font-bold text-3xl lg:text-5xl text-foreground mb-6">
            Lihat Transformasi AC Anda
          </h2>
          <p className="text-xl text-muted-foreground max-w-3xl mx-auto">
            Bukti nyata kualitas layanan kami melalui dokumentasi sebelum dan sesudah perbaikan. 
            Geser slider untuk melihat perbedaannya!
          </p>
        </div>

        {/* Main Gallery */}
        <div className="bg-white rounded-2xl p-8 shadow-card border border-border mb-8">
          {/* Navigation */}
          <div className="flex items-center justify-between mb-8">
            <div>
              <h3 className="font-heading font-bold text-2xl text-foreground mb-2">
                {currentItem?.title}
              </h3>
              <div className="flex items-center text-muted-foreground">
                <Icon name="MapPin" size={16} className="mr-2" />
                <span>{currentItem?.location}</span>
              </div>
            </div>
            <div className="flex items-center space-x-2">
              <Button
                variant="outline"
                size="icon"
                onClick={prevSlide}
                className="w-10 h-10"
              >
                <Icon name="ChevronLeft" size={20} />
              </Button>
              <span className="text-sm text-muted-foreground px-3">
                {activeSlide + 1} / {galleryItems?.length}
              </span>
              <Button
                variant="outline"
                size="icon"
                onClick={nextSlide}
                className="w-10 h-10"
              >
                <Icon name="ChevronRight" size={20} />
              </Button>
            </div>
          </div>

          {/* Before/After Slider */}
          <div className="relative mb-8">
            <div className="relative w-full h-96 rounded-xl overflow-hidden">
              {/* Before Image */}
              <img
                src={currentItem?.beforeImage}
                alt={`Sebelum - ${currentItem?.title}`}
                className="absolute inset-0 w-full h-full object-cover"
              />
              
              {/* After Image with Clip Path */}
              <div 
                className="absolute inset-0 overflow-hidden"
                style={{ clipPath: `inset(0 ${100 - sliderPosition}% 0 0)` }}
              >
                <img
                  src={currentItem?.afterImage}
                  alt={`Sesudah - ${currentItem?.title}`}
                  className="w-full h-full object-cover"
                />
              </div>

              {/* Slider Control */}
              <div className="absolute inset-0 flex items-center">
                <input
                  type="range"
                  min="0"
                  max="100"
                  value={sliderPosition}
                  onChange={handleSliderChange}
                  className="w-full h-full opacity-0 cursor-col-resize"
                />
              </div>

              {/* Slider Line */}
              <div 
                className="absolute top-0 bottom-0 w-1 bg-white shadow-lg"
                style={{ left: `${sliderPosition}%`, transform: 'translateX(-50%)' }}
              >
                <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-8 h-8 bg-white rounded-full shadow-lg flex items-center justify-center">
                  <Icon name="Move" size={16} className="text-primary" />
                </div>
              </div>

              {/* Labels */}
              <div className="absolute top-4 left-4 bg-destructive text-white px-3 py-1 rounded-full text-sm font-semibold">
                Sebelum
              </div>
              <div className="absolute top-4 right-4 bg-secondary text-white px-3 py-1 rounded-full text-sm font-semibold">
                Sesudah
              </div>
            </div>

            {/* Instructions */}
            <div className="text-center mt-4">
              <p className="text-sm text-muted-foreground">
                <Icon name="MousePointer" size={16} className="inline mr-2" />
                Geser slider untuk melihat perbandingan sebelum dan sesudah
              </p>
            </div>
          </div>

          {/* Details */}
          <div className="grid md:grid-cols-3 gap-6">
            <div className="text-center p-4 bg-destructive/5 rounded-xl">
              <Icon name="AlertTriangle" size={24} className="text-destructive mx-auto mb-3" />
              <h4 className="font-semibold text-foreground mb-2">Masalah</h4>
              <p className="text-sm text-muted-foreground">{currentItem?.problem}</p>
            </div>
            <div className="text-center p-4 bg-primary/5 rounded-xl">
              <Icon name="Wrench" size={24} className="text-primary mx-auto mb-3" />
              <h4 className="font-semibold text-foreground mb-2">Solusi</h4>
              <p className="text-sm text-muted-foreground">{currentItem?.solution}</p>
            </div>
            <div className="text-center p-4 bg-secondary/5 rounded-xl">
              <Icon name="CheckCircle" size={24} className="text-secondary mx-auto mb-3" />
              <h4 className="font-semibold text-foreground mb-2">Hasil</h4>
              <p className="text-sm text-muted-foreground">{currentItem?.result}</p>
            </div>
          </div>
        </div>

        {/* Gallery Thumbnails */}
        <div className="grid md:grid-cols-3 gap-6">
          {galleryItems?.map((item, index) => (
            <button
              key={item?.id}
              onClick={() => {
                setActiveSlide(index);
                setSliderPosition(50);
              }}
              className={`relative bg-white rounded-xl p-4 shadow-card border-2 transition-all duration-300 text-left ${
                activeSlide === index 
                  ? 'border-primary shadow-lg' 
                  : 'border-border hover:border-primary/50'
              }`}
            >
              <div className="relative h-32 rounded-lg overflow-hidden mb-4">
                <img
                  src={item?.beforeImage}
                  alt={item?.title}
                  className="w-full h-full object-cover"
                />
                {activeSlide === index && (
                  <div className="absolute inset-0 bg-primary/20 flex items-center justify-center">
                    <Icon name="Play" size={24} className="text-white" />
                  </div>
                )}
              </div>
              <h4 className="font-semibold text-foreground mb-1">{item?.title}</h4>
              <p className="text-sm text-muted-foreground">{item?.location}</p>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BeforeAfterGallery;